import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import "../../Styles/_color_variables.css";
import { Select } from "antd";
import { useTranslation } from "react-i18next";
import NoDataIcon from "../../assets/svg/no-data.svg";

const lineColors = ["#2697F4", "#7CC5F4"]; // Define the line colors for TMS and GMS

const GmsTmsGraphs = ({ gmsTmsData }) => {
  const { t } = useTranslation();

  const [selectedPeriod, setSelectedPeriod] = useState("yearly");

  const [graphData, setGraphData] = useState([]);

  useEffect(() => {
    if (gmsTmsData && gmsTmsData.length > 0) {
      const gms = gmsTmsData[0]?.gms?.getCompletedGms[selectedPeriod] || [];
      const tms = gmsTmsData[0]?.tms?.getCompletedGms[selectedPeriod] || [];

      const newData = [
        {
          id: "TMS",
          data: tms.map((item) => ({ x: item?.date, y: item?.count }))
        },
        {
          id: "GMS",
          data: gms.map((item) => ({ x: item?.date, y: item?.count }))
        }
      ];
      setGraphData(newData);
    }
  }, [gmsTmsData, selectedPeriod]);

  const handleChange = (value) => {
    setSelectedPeriod(value);
  };

  const options = {
    chart: {
      type: "area",
      height: "auto"
    },
    grid: {
      line: {
        stroke: "lightgray",
        strokeWidth: 0.6,
        strokeDasharray: "5 5"
      },
      borderColor: 'lightgray',
      strokeDashArray: 4,
    },
    crosshairs: {
      stroke: {
        color: "#7CC5F4",
        width: 1,
        dashArray: 3
      }
    },
    fill: {
      type: "gradient"
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return ` ${val}`;
      },
      background: {
        opacity: 0.5
      },
      padding: "5px",
    },
    stroke: {
      curve: "smooth",
      width: 3,
    },
    
    tooltip: {
      x: {
        format: "dd/MM/yy"
      },
      y: {
        title: "Entries",
        formatter: function (val) {
          return `${t("Completion Rate")}: ${val}`;
        }
      }
    },
    xaxis: {
      type: "datetime",
      categories: [],
      labels: {
        style: {
          colors: "var(--stat-text)"
        }
      }
    },
    yaxis: {
      show: true,
      labels: {
        style: {
          colors: "var(--stat-text)"
        }
      }
    },
    toolbar: {
      show: false
    },
    legend: {
      position: 'top',
      horizontalAlign: 'left',
      labels: {
        colors: ["var(--stat-text)","var(--stat-text)"] 
      }
    }
  };

  return (
    <div className='overview-user-section overview-section'>
      <div className='overview-heading mt-3 flex flex-row justify-between items-center' style={{alignItems: "center", paddingRight:"1rem", paddingLeft:"1.4rem"}}>
        <h4 className='overview-text'>{t("GMS & TMS Completion Rate")}</h4>
        <div className='flex'>
          <Select
            style={{ width: "120px" }}
            className='m-auto'
            placeholder={t("Select")}
            onChange={handleChange}
            value={selectedPeriod}
          >
            <Select.Option value='weekly'>{t("weekly")}</Select.Option>
            <Select.Option value='monthly'>{t("monthly")}</Select.Option>
            <Select.Option value='quarterly'>{t("quarterly")}</Select.Option>
            <Select.Option value='halfYearly'>{t("halfYearly")}</Select.Option>
            <Select.Option value='yearly'>{t("yearly")}</Select.Option>
          </Select>
        </div>
      </div>
      <div
        style={{
          height: "85%",
          width: "100%",
          padding: "10px 10px",
          marginTop: "10px"
        }}
      >
        {graphData.length === 0 ? (
          <div className='flex flex-col justify-center items-center overview-error'>
            <img src={NoDataIcon} alt='No data' />
            <span>{t("noDataAvailable")}</span>
          </div>
        ) : (
          <Chart
            height='100%'
            options={{
              ...options,
              xaxis: {
                ...options.xaxis,
                categories: graphData[0]?.data.map((item) => item?.x)
              }
            }}
            series={graphData.map((item, index) => ({
              name: item?.id,
              data: item?.data.map((dataItem) => dataItem?.y),
              color: lineColors[index]
            }))}
            type='area'
          />
        )}
      </div>
    </div>
  );
};

export default GmsTmsGraphs;
